import React from "react";
import PropTypes from 'prop-types';
import {useTranslation} from "react-i18next";
import ReactHookFormText from "./rhf/ReactHookFormText";

function FormText({field}) {
    const {t} = useTranslation();

    return (
        <ReactHookFormText
            id={field.id}
            label={t(field.label)}
            defaultValue={field.defaultValue}
            variant="filled"
            name={field.id}
            multiline={field.multiline}
            disabled={field.disabled}
            rules={field.rules}
            rows={field.rows}
        />
    )
}

FormText.propTypes = {
    field: PropTypes.shape({
        rowSize: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        defaultValue: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        multiline: PropTypes.bool,
        disabled: PropTypes.bool.isRequired,
        id: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    }).isRequired
}

export default FormText;